export default __webpack_public_path__ + "assets/media/placeholder-video-mediathek-gradient.02049417.svg";